import './info-alert.scss';

import Alert from 'antd/es/alert';

import { checkIcon } from '@/constants';
import InfoCircle from '@/media/icons/info-circle.svg?react';
import { useAppSelector } from '@/store';

const InfoAlert: React.FC = () => {
  const { instructionsText } = useAppSelector((state) => state.financingStep);

  if (!instructionsText.main) return null;
  return (
    <div className="info-alert">
      <Alert
        className="info-alert__alert"
        title={
          <div className="info-alert__alert-text">
            {instructionsText.isSuccess ? (
              <img className="info-alert__alert-success-icon" src={checkIcon} />
            ) : (
              <InfoCircle />
            )}
            <div>
              <p>{instructionsText.main}</p>
              {!!instructionsText.secondary && (
                <p className="info-alert__alert-secondary">
                  {instructionsText.secondary}
                </p>
              )}
            </div>
          </div>
        }
        type={instructionsText.isSuccess ? 'success' : 'warning'}
      />
    </div>
  );
};

export default InfoAlert;
